import { gql } from '@apollo/client';

export const DELETE_QUIZ = gql`
  mutation DeleteQuiz($quizUuid: String!) {
    deleteQuiz(quizUUID: $quizUuid) {
      message
    }
  }
`;
